import { include } from 'named-urls'

const routes = {
  root: '/',

  subscribe: include('/subscribe', {
    main: '',
    checkout: 'checkout',
  }),

  login: include('/login', {
    main: '',
    token: 'token/:recurrenceAuthToken',
  }),

  password: include('/password', {
    reset: 'reset',
    change: 'change/:token',
    firstAccess: 'first-access/:token',
  }),

  contracts: include('/contracts', {
    all: '',
    new: 'new',
    show: ':contractId/show',
    edit: ':contractId/edit',
    logs: ':contractId/logs',
    suspend: ':contractId/suspend',
    entries: include('/contracts/', {
      new: ':contractId/entries',
    }),

    migratePlan: include(':contractId/contract-plans/:contractPlanId/migrate', {
      steps: include('steps', {
        main: ':step',
        show: 'show',
        edit: 'edit',
        confirm: 'confirm',
      }),
    }),
  }),

  contractPlans: include('/contract-plans', {
    logs: ':contractPlanId/logs',
  }),

  plans: include('/plans', {
    all: '',
    new: 'new',
    show: ':planId/show',
    edit: ':planId/edit',
    logs: ':planId/logs',
  }),

  contractInvoices: include('/contracts', {
    new: ':contractId/invoices',
  }),

  invoices: include('/invoices', {
    all: '',
    show: ':invoiceId/show',
    edit: ':invoiceId/edit',
    logs: ':invoiceIdentifier/logs',
    steps: include('steps', {
      main: ':step',
      selectCustomer: 'select-customer',
      selectPlan: 'select-plan',
      settings: 'settings',
      confirm: 'confirm',
    }),
  }),

  orders: include('/orders', {
    logs: ':orderId/logs',
  }),

  clients: include('/clients', {
    all: '',
    new: 'new',
    show: ':clientId/show',
    edit: ':clientId/edit',
    editAddress: ':clientId/edit-address',
    logs: ':clientId/logs',
  }),

  taxInvoices: include('/tax-invoices', {
    all: '',
    new: 'new',
    show: ':taxInvoiceId/show',
    edit: ':taxInvoiceId/edit',
    logs: ':taxInvoiceId/logs',
  }),

  entries: include('/entries', {
    logs: ':entryId/logs',
  }),

  users: include('/settings/users', {
    new: 'new',
    edit: ':userId/edit',
  }),

  settings: include('/settings', {
    all: '',
    logs: ':settingId/logs',

    account: include('account/', {
      logs: ':sellerId/logs',
    }),

    taxes: include('taxes/', {
      logs: ':taxId/logs',
    }),

    taxTypes: include('tax-types/', {
      logs: ':taxTypeId/logs',
    }),

    users: include('users/', {
      new: 'new',
      edit: ':userId/edit',
      logs: ':userId/logs',
    }),

    profiles: include('profiles/', {
      new: 'new',
      edit: ':profileId/edit',
    }),

    emails: include('emails/', {
      logs: ':emailId/logs',
    }),

    paymentMethods: include('payment-methods', {
      main: '',
      edit: 'edit',
      steps: include('steps', {
        main: ':step',
        integrationToken: 'integration-token',
        selectMethods: 'select-methods',
        configuration: 'configuration',
      }),
    }),
  }),

  dashboard: '/dashboard',

  notFound: '/not-found',
}

export default routes
